import React from 'react';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { Card } from './ui/card';

const Contact = () => {
  const contactInfo = [
    {
      icon: Phone,
      title: 'Phone',
      details: [
        { number: '+1 786 939 29 80', hasWhatsApp: false },
        { number: '+1 786 637 9167', hasWhatsApp: true },
        { number: '+90 541 354 58 25', hasWhatsApp: false }
      ]
    },
    {
      icon: Mail,
      title: 'Email',
      details: ['support@milamiausa.com']
    },
    {
      icon: MapPin,
      title: 'Address',
      details: ['MILA MIA USA LLC', '150 SE 2nd Ave #1004', 'Miami, Florida 33131']
    }
  ];

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <span className="section-label">Contact Us</span>
          <h2 className="section-title">Let's Start a Conversation</h2>
          <p className="section-description">
            Ready to transform your e-commerce customer experience? Get in touch with us today.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info contact-info-centered">
            {contactInfo.map((info, index) => {
              const IconComponent = info.icon;
              return (
                <Card key={index} className="contact-info-card">
                  <div className="contact-info-icon-wrapper">
                    <IconComponent className="contact-info-icon" size={24} />
                  </div>
                  <div className="contact-info-content">
                    <h3 className="contact-info-title">{info.title}</h3>
                    {info.title === 'Phone' ? (
                      info.details.map((detail, idx) => (
                        <div key={idx} className="contact-info-phone-wrapper">
                          {detail.hasWhatsApp && (
                            <MessageCircle className="whatsapp-icon" size={16} />
                          )}
                          <p className="contact-info-detail">{detail.number}</p>
                        </div>
                      ))
                    ) : (
                      info.details.map((detail, idx) => (
                        <p key={idx} className="contact-info-detail">{detail}</p>
                      ))
                    )}
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;